module.exports = __webpack_public_path__ + "img/logo2.6b3af372.png";